// Karuzela katalogu. Przewijanie, przeciaganie palcem i klawiatura robi
// natywny scroll-snap - tutaj sa tylko trzy rzeczy, ktorych CSS nie umie:
// ktora karta jest na srodku, strzalki i kropki.
(() => {
  const init = (root) => {
    if (root.dataset.aiofmBound) return;
    root.dataset.aiofmBound = '1';

    const track = root.querySelector('[data-aiofm-car-track]');
    const items = [...root.querySelectorAll('[data-aiofm-car-item]')];
    const prev = root.querySelector('[data-aiofm-car-prev]');
    const next = root.querySelector('[data-aiofm-car-next]');
    const dots = root.parentElement.querySelector('[data-aiofm-car-dots]');
    if (!track || items.length === 0) return;

    // Ktora karta jest najblizej srodka toru. Liczymy wzgledem TORU,
    // nie viewportu - "srodkowa" ma znaczyc srodek karuzeli.
    const centeredIndex = () => {
      const box = track.getBoundingClientRect();
      const mid = box.left + box.width / 2;
      let best = 0;
      let bestDist = Infinity;
      items.forEach((el, i) => {
        const r = el.getBoundingClientRect();
        const d = Math.abs(r.left + r.width / 2 - mid);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      return best;
    };

    let current = -1;

    const paint = () => {
      const idx = centeredIndex();
      if (idx === current) return;
      current = idx;
      items.forEach((el, i) => el.toggleAttribute('data-centered', i === idx));
      if (dots) {
        [...dots.children].forEach((d, i) => d.toggleAttribute('data-on', i === idx));
      }
      if (prev) prev.disabled = idx === 0;
      if (next) next.disabled = idx === items.length - 1;
    };

    let queued = false;
    const onScroll = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; paint(); });
    };

    const calm = window.matchMedia('(prefers-reduced-motion: reduce)');

    // Przesuwamy TOR o roznice srodkow, zamiast wolac scrollIntoView.
    // scrollIntoView przewinaloby takze STRONE w pionie, zeby pokazac
    // karuzele - na wejsciu na /pages/the-manuals dawaloby to skok.
    // Roznica srodkow z getBoundingClientRect dziala niezaleznie od tego,
    // ktory przodek jest offsetParent.
    const centerOn = (el, smooth) => {
      const t = track.getBoundingClientRect();
      const r = el.getBoundingClientRect();
      const delta = r.left + r.width / 2 - (t.left + t.width / 2);
      track.scrollBy({
        left: delta,
        behavior: smooth && !calm.matches ? 'smooth' : 'auto',
      });
    };

    const go = (delta) => {
      const target = items[Math.min(items.length - 1, Math.max(0, centeredIndex() + delta))];
      if (target) centerOn(target, true);
    };

    prev?.addEventListener('click', () => go(-1));
    next?.addEventListener('click', () => go(1));
    track.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    if (dots) {
      dots.replaceChildren(...items.map(() => {
        const d = document.createElement('span');
        d.className = 'aiofm-car-dot';
        return d;
      }));
    }

    // Karta wysrodkowana na starcie. Bez animacji - to stan poczatkowy, nie ruch.
    const start = Number(root.dataset.initial || 0);
    if (items[start]) centerOn(items[start], false);
    paint();
  };

  const initAll = () => document.querySelectorAll('[data-aiofm-carousel]').forEach(init);

  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
